import style from './AccordionElement.css';
import { TemplateElement } from '../../01-base/TemplateElement';

class AccordionElement extends TemplateElement {
    constructor() {
        super(null, { autoRender: true, styles: [style] });
    }

    hooks() {
        return {
            connected: () => {
                if (!this.open) this.collapse();
            },
        };
    }

    template() {
        if (this.usedForList) {
            return `
            <div class="accordion-content global-styles">
                <div class="title-wrapper container px-1" ref="title">
                    <div class="${
                        this.open ? 'content-underline' : ''
                    } d-flex row minimal-gutters align-items-center justify-content-between ">
                        <slot name="title" class=""></slot>
                        <div class="icon-wrapper">
                            <div ref="plus" class="plus ${this.open ? 'd-none' : ''}"></div>
                            <div class="minus"></div>
                        </div>
                    </div>
                </div>
                <div class="content-wrapper" ref="content">
                    <slot name="content"></slot>
                </div>
            </div>
        `;
        }
        return `
             <div class="accordion-content global-styles">
                <div class="title-wrapper" ref="title">
                    <div>
                        <slot name="title" class=""></slot>
                        <p class="${this.color} ${this.alignmentOpenText} ${this.textSize} curserchange" ref="plus">${this.openText}</p>
                    </div>
                </div>
                <div class="content-wrapper" ref="content">
                    <slot name="content"></slot>
                    <p class="${this.color} ${this.alignmentCloseText} ${this.textSize} curserchange" ref="minus">${this.closeText}</p>
                </div>
            </div>
        `;
    }

    properties() {
        return {
            open: false,
            clickable: true,
            usedForList: true,
            openText: 'weiter lesen ...',
            closeText: 'schließen',
            color: 'text-primary',
            alignmentOpenText: 'text-left',
            alignmentCloseText: 'text-left',
            textSize: 'text-medium',
        };
    }

    watch() {
        return {
            open: (_, open) => {
                open === true ? this.expand() : this.collapse();
            },
        };
    }

    events() {
        return {
            '[ref="title"]': {
                click: () => {
                    if (this.clickable) {
                        this.toggle();
                        const accordions = document.querySelectorAll('accordion-element');
                        accordions.forEach(accordion => {
                            if (accordion !== this) {
                                accordion.open = false;
                            }
                        });
                    }
                },
            },
            '[ref="minus"]': {
                click: () => {
                    if (this.clickable) {
                        this.toggle();
                        const accordions = document.querySelectorAll('accordion-element');
                        accordions.forEach(accordion => {
                            if (accordion !== this) {
                                accordion.open = false;
                            }
                        });
                    }
                },
            },
        };
    }

    toggle() {
        this.open = !this.open;
    }

    collapse() {
        this.$refs.plus.classList.remove('d-none');

        const contentHeight = this.$refs.content.scrollHeight;

        const elementTransition = this.$refs.content.style.transition;
        this.$refs.content.style.transition = '';

        requestAnimationFrame(() => {
            this.$refs.content.style.height = contentHeight + 'px';
            this.$refs.content.style.transition = elementTransition;

            requestAnimationFrame(() => {
                this.$refs.content.style.height = 0 + 'px';
            });
        });

        this.$refs.content.setAttribute('data-collapsed', 'true');
    }

    expand() {
        const content = this.$refs.content;
        this.$refs.plus.classList.add('d-none');
        content.addEventListener(
            'transitionend',
            function() {
                // content.style.height = null;
            },
            { once: true },
        );

        content.setAttribute('data-collapsed', 'false');

        setTimeout(function() {
            const contentHeight = content.scrollHeight;
            content.style.height = contentHeight + 'px';
        }, 100);
    }
}

customElements.define('accordion-element', AccordionElement);
